<template>
  <svg :class="svgClass" aria-hidden="true" :width="size" :height="size">
    <defs v-if="colors">
      <linearGradient id="linear" x1="100%" y2="100%">
        <stop v-for="(it, ix) in colors" :key="ix" :offset="it.offset" :stop-color="it.color"
          :stop-opacity="it.opacity ? it.opacity : '100%'"></stop>
      </linearGradient>
    </defs>
    <use :href="name" :fill="colors ? 'url(#linear)' : color" :color="colors ? 'url(#linear)' : color" />
  </svg>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  class: {
    type: String,
    default: "",
  },
  color: {
    type: String,
    default: "currentColor",
  },
  colors: {
    type: Object,
  },
  size: {
    type: String,
    default: "100%",
  },
});

const name = computed(() => {
  return `#icon-${props.name}`;
});

const svgClass = computed(() => {
  if (props.class) {
    return props.class;
  }
});

const color = computed(() => {
  return props.color;
});

const colors = computed(() => {
  return props.colors;
});
</script>

<style scoped>
.svg-external-icon {
  background-color: currentColor;
  mask-size: cover !important;
  display: inline-block;
}
</style>
